export type WidgetFaqQuestion = {
  id: string;
  question: string;
  sortOrder: number;
};

export const FAQ_CHAT_LABEL = 'chat';
export const FAQ_QUESTIONS_SERVERLESS_URL =
  '_api/wix-ai-assistant-faq/faq/questions';
export const faqQuestionServerlessUrl = (id: string) =>
  `${FAQ_QUESTIONS_SERVERLESS_URL}/${id}`;

export const toWidgetFaqQuestions = (
  entries: Record<string, any>[],
): WidgetFaqQuestion[] =>
  entries
    .filter((e) => e.id && e.question)
    .map((entry) => ({
      id: entry.id as string,
      question: entry.question as string,
      sortOrder:
        (
          entry.labels as { title: string; sortOrder?: number }[] | undefined
        )?.find((l) => l.title === FAQ_CHAT_LABEL)?.sortOrder ?? 0,
    }))
    .sort((a, b) => a.sortOrder - b.sortOrder);

type DraftjsTextData = {
  text: string;
  decorations: unknown[];
};

type DraftjsParagraphData = {
  textStyle: {
    textAlignment: string;
  };
  indentation: number;
};

type DraftjsNode = {
  type: string;
  id: string;
  nodes: DraftjsNode[];
  textData?: DraftjsTextData;
  paragraphData?: DraftjsParagraphData;
};

type DraftjsMetadata = {
  version: number;
  createdTimestamp: string;
  updatedTimestamp: string;
  id: string;
};

type DraftjsContent = {
  nodes: DraftjsNode[];
  metadata: DraftjsMetadata;
};

type FaqQuestionLabel = {
  title: string;
  sortOrder: number;
};

export type FaqQuestionEntry = {
  id: string;
  revision: string;
  createdDate: string;
  updatedDate: string;
  question: string;
  draftjs: string;
  labels: FaqQuestionLabel[];
  sortOrder: number;
  status: string;
  categoryId: string;
  slug: string;
  shareLink: string;
};

function isDraftjsContent(value: unknown): value is DraftjsContent {
  return (
    typeof value === 'object' &&
    value !== null &&
    'nodes' in value &&
    Array.isArray((value as DraftjsContent).nodes) &&
    'metadata' in value &&
    typeof (value as DraftjsContent).metadata === 'object'
  );
}

export function extractAnswerText(draftjsString: string): string {
  const parsed = JSON.parse(draftjsString);
  if (isDraftjsContent(parsed)) {
    return parsed.nodes
      .flatMap((node) => node?.nodes)
      .filter((n) => n.type === 'TEXT')
      .map((n) => n.textData?.text)
      .join('\n');
  }

  return '';
}
